//=============================================================================
// Lazy Loads Images
//=============================================================================


export default class ImageLoader {
  //===========================================================================
  // Constructor
  //===========================================================================

  constructor(init) {
    if (init) {
      this.state = {};

      this.initLoad();
      this.setupEventListeners();
    }
  }

  //===========================================================================
  // Sets the state and loads images
  //===========================================================================

  initLoad() {
    this.setState();
    this.revealImages();
  }

  //===========================================================================
  // Sets the state
  //===========================================================================

  setState() {
    this.state.$images = $('[data-image-src]:not([data-lazy-load-lock]), [data-bg-image]:not([data-lazy-load-lock])');
  }

  //===========================================================================
  // Loads images if they are onscreen or within nearby scrolling distance
  //===========================================================================

  revealImages() {
    let imagesRevealed = false;

    this.state.$images.each((i, el) => {
      let bounds = el.getBoundingClientRect();

      if (bounds.top < (window.innerHeight + 1500)) {
        imagesRevealed = true;
        this.revealImage(el);
      }
    });

    if (imagesRevealed) {
      setTimeout(() => {
        this.setState();
      }, 200);
    }
  }

  //===========================================================================
  // Loads and reveals a single image
  //===========================================================================

  revealImage(el) {
    const $el = $(el);
    const imgUrl = $el.data('image-src') ? $el.data('image-src') : $el.data('bg-image');
    const dummyImg = document.createElement("img");

    if (el && imgUrl) {
      dummyImg.src = imgUrl;
      dummyImg.addEventListener('load', () => {
        if ($el.data('image-src')) {
          el.src = imgUrl;
        } else if ($el.data('bg-image')) {
          $el.css({ 'backgroundImage': `url(${ imgUrl })` });
        }

        $el.removeClass('invisible');
        $el.removeAttr('data-image-src');
        $el.removeAttr('data-bg-image');
        dummyImg.remove();

        setTimeout(() => {
          $el.removeClass('transition--visible');
        }, 600);
      });
    }
  }

  //===========================================================================
  // Sets up event listeners
  //===========================================================================

  setupEventListeners() {
    $(window).on('resize', this.revealImages.bind(this));
    $(window).on('scroll', this.revealImages.bind(this));
    $(document).on('revealImages', this.initLoad.bind(this));
    $(document).on('historyChange', this.initLoad.bind(this));
  }
}
